import * as i0 from '@angular/core';
import { Component, ChangeDetectionStrategy } from '@angular/core';

class PanelHeaderComponent {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.7", ngImport: i0, type: PanelHeaderComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.0.7", type: PanelHeaderComponent, isStandalone: true, selector: "kb-panel-header", ngImport: i0, template: "<ng-content></ng-content>\n", styles: [""], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.7", ngImport: i0, type: PanelHeaderComponent, decorators: [{
            type: Component,
            args: [{ selector: 'kb-panel-header', changeDetection: ChangeDetectionStrategy.OnPush, standalone: true, imports: [], template: "<ng-content></ng-content>\n" }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { PanelHeaderComponent };
